import React, { useState } from 'react';
const Ditta_form_mail_uscita = (props) => {

    const [value, setValue] = useState();

    const handleSubmit1 = (e) => {
        alert('scrivi qualcosa')

    }

    return (
        <div>
            <h3>Grazie per la risposta</h3>
            <p>
                A presto
        </p>
        </div>
    )
}
export default Ditta_form_mail_uscita;
